"use client";

import { Button } from "@/components/ui/button";
import { NodeViewContent, NodeViewWrapper } from "@tiptap/react";
import { Clipboard, ClipboardCopy } from "lucide-react";
import React, { useState } from "react";
import toast from "react-hot-toast";

const CodeblockCopy = (props: any) => {
  const [copyClicked, setCopyClicked] = useState<boolean>(false);

  async function handleCopyClicked(e: any) {
    e.preventDefault();
    setCopyClicked(true);
    const clipboard = navigator.clipboard;
    const value = props.node.content.content[0].text;
    if (clipboard !== undefined && typeof clipboard !== "undefined") {
      navigator.clipboard.writeText(value);
      toast.success("Code Copied to Clipboard");
    } else {
      if (document.execCommand) {
        const el = document.createElement("textarea");
        el.value = value;
        document.body.append(el);
        el.select();
        el.setSelectionRange(0, value.length);
        if (document.execCommand("copy")) {
          toast.success("Code Copied to Clipboard");
        }
        el.remove();
      } else {
        toast.error("Error Copying to Clipboard");
      }
    }

    setTimeout(() => {
      setCopyClicked(false);
    }, 1500);
  }

  return (
    <NodeViewWrapper className="code-block relative">
      {!props.editor.view.editable && (
        <Button
          type="button"
          className="absolute right-0 h-8"
          onClick={(e) => handleCopyClicked(e)}
          title={`Copy Code to Clipboard`}
          disabled={copyClicked}
        >
          {copyClicked ? (
            <ClipboardCopy className="h-4 w-4" />
          ) : (
            <Clipboard className="h-4 w-4" />
          )}
        </Button>
      )}
      <pre>
        <NodeViewContent as="code" />
        {props.node.attrs.language && (
          <span className="absolute bottom-1 right-[5px] text-xs text-muted-foreground">
            {props.node.attrs.language}
          </span>
        )}
      </pre>
    </NodeViewWrapper>
  );
};

export default CodeblockCopy;
